import React from 'react';
import ConsultaFlotante from '../botonConsultar/boton-cosultar';

const VacacionesMedida = (props) => {
  let queryString = '?type=Paquete';

  const armarUrl = () => {
    const urlString = window.location.href;
    return new URL(urlString);
  };

  const url = armarUrl();

  const habitaciones = url.searchParams.get('h') ? `&h=${url.searchParams.get('h')}` : '';

  let destino = props.destino ? `&destino=${props.destino}` : url.searchParams.get('d');

  destino = (props.proveedorId === 5 || props.proveedorId === '5') ? `&destino=${destino.split(';')[1]}` : destino;

  const fechaSalida = props.fechaSalida ? `&desde=${props.fechaSalida}` : '';

  const cantidadNoches = props.cantidadNoches ? `&cantidadNoches=${props.cantidadNoches}` : '';

  if (props.referencia !== '' && props.referencia !== undefined) {
    const basicUrl = '?type=PaqueteAMedida';
    const { referencia } = props;
    queryString = `${basicUrl}&referencia=${referencia}${habitaciones}&proveedorId=${props.proveedorId}${destino}${fechaSalida}${cantidadNoches}&id_producto=${url.searchParams.get('i')}`;
  }

  return (
    <div className='seccion hidden'>
      <ConsultaFlotante url={`${process.env.RAZZLE_URL_PATH}/consulta${queryString}`} />
      <div className='panel panel-default custom bordeado consulta'>
        <div className='panel-body consulta'>
          <div className='col-lg-8'>
            <div className='row'>
              <span className='titulo consulta pull-left'>
                ¿Necesitás hacer alguna modificación?
                {' '}
                <b>Podemos armar tus vacaciones a medida</b>
              </span>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='row text-center'>
              <a className='btn color-dinamico-fondo' href={`${process.env.RAZZLE_URL_PATH}/consulta${queryString}`}>Consulta a un experto</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VacacionesMedida;
